import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import './../../css/NotFound.scss';
//import NotFoundImage from '../../assets/images/undraw_page_not_found.svg';
import Button from '../Button/Button';

const NotFound: FC = (): JSX.Element => {
    return (
        <>
            <img className="error-404"  alt="Page Not Found" />
            <Link to="/caticlick">
                <Button children={<span>Return to Home Page</span>} />
            </Link>
        </>
    );
};

export default NotFound;
